import {
  ParsedInitialState,
  StateSelection,
} from '@/scopes/prices/infrastructure/parser/pricesFilterParserWithInitState'
import { PricesState } from '@/scopes/prices/infrastructure/store'
import { QueryParametersToStateMapper } from '@/scopes/prices/infrastructure/types'

export type PricesStateWithStateSelection = Partial<PricesState> & { StateSelection?: StateSelection }

export type PricesQueryParameterToStateMapper = QueryParametersToStateMapper<PricesStateWithStateSelection, ParsedInitialState>

export function createPricesQueryParametersToStateMapper(): PricesQueryParameterToStateMapper {
  function getToStateWithInitialState() {
    return (queryParameters: ParsedInitialState) => {
      const { StateSelection, ...filterSelection } = queryParameters
      return {
        filterSelection,
        StateSelection,
      }
    }
  }

  function getToParametersWithInitialState() {
    return (parameters: PricesStateWithStateSelection) => {
      const { selectedPriceId, selectedRooms, filterSelection, selectedOutboundRouteId, selectedInboundRouteId, roomsResponse, selectedOutboundBusId, selectedInboundBusId } = parameters

      const roomsLength = roomsResponse?.roomGroups?.length ?? 0

      const room = Array.from({ length: roomsLength }).map((_, i) => {
        return selectedRooms && selectedRooms[i + 1] ? `${selectedRooms[i + 1]}` : 'empty'
      }).join(',')

      return {
        ...filterSelection,
        selectedPriceId,
        ...(room ? { room } : {}),
        selectedOutboundRouteId,
        selectedInboundRouteId,
        selectedOutboundBusId,
        selectedInboundBusId,
      }
    }
  }

  return {
    toState: getToStateWithInitialState(),
    toParameters: getToParametersWithInitialState(),
  }
}
